import './tab-collection.scss';

const strings = {
  attrResults: 'data-filter-result',
  attrSearch: 'data-pill-filter-search',
  attrPillFilterTemplate: 'data-pill-filter-template',
};

const selectors = {
  tabContainer: '[tab-collection="tabContainer"]',
  tabButtons: '[tab-collection="tabButton"]:not([data-pill-filter-template])',
  tabLink: '[tab-collection="tabLink"]',
  tabContents: '[tab-collection="tabContent"]',
  cards: '.product-card',
  tabSkeleton: '[tab-collection="tabSkeleton"]',
};


const event = new CustomEvent('Alessi:loadMoreEnd');

const getCurrentFilterLink = (container, categoryFilter) => {
  return `https://${window.location.hostname}${Shopify.routes.root}collections/${container.getAttribute('data-collection')}?${categoryFilter}`;
};

function hideAllContents(container) {
  const tabContents = container.querySelectorAll(selectors.cards);
  tabContents.forEach((content) => {
    content.style.display = 'none';
  });
}

function showCachedContents(container, filterLink) {
  const tabContents = container.querySelectorAll(selectors.cards);
  tabContents.forEach((content) => {
    if (content.getAttribute(strings.attrResults) === filterLink) {
      content.style.display = 'block';
    }
  });
}

function removeCurrentClassFromButtons(container) {
  const tabButtons = container.querySelectorAll(selectors.tabButtons);
  tabButtons.forEach((button) => {
    button.classList.remove('current');
  });
}

function updateTabLinks(container, filterLink) {
  // Loop through all to update mobile link too, which is a different button
  const tabLinks = container.querySelectorAll(selectors.tabLink);
  tabLinks.forEach((tabLink) => {
    tabLink.href = filterLink;
  });
  return filterLink;
}

async function fetchAndDisplayProducts(container, tabIndex) {
  const selectedButton = container.querySelectorAll(selectors.tabButtons)[tabIndex];
  const categoryFilter = selectedButton.getAttribute(strings.attrSearch);
  const filterLink = getCurrentFilterLink(container, categoryFilter);
  updateTabLinks(container, filterLink);
  const cachedResults = container.querySelectorAll('[' + strings.attrResults + '="' + filterLink + '"]');
  hideAllContents(container, filterLink);

  if (cachedResults.length) {
    const skeleton = container.querySelector(selectors.tabSkeleton);

    showCachedContents(container, filterLink);
    document.dispatchEvent(event);
    skeleton.style.display = 'none';
  } else {
    try {
      const skeleton = container.querySelector(selectors.tabSkeleton);
      skeleton.style.display = 'block';

      const res = await fetch(filterLink);
      const html = await res.text();
      const parser = new DOMParser();
      const productCards = parser.parseFromString(html, 'text/html').querySelectorAll('.product-card');
      const tabContent = container.querySelector(selectors.tabContents).querySelector('.products-list__grid');

      const maxProductsToFetch = container.getAttribute('products-limit');
      const limitedProductCards = Array.from(productCards).slice(0, maxProductsToFetch);

      limitedProductCards.forEach((productCard) => {
        const cardClone = productCard.cloneNode(true);
        cardClone.setAttribute(strings.attrResults, filterLink);
        tabContent.appendChild(cardClone);
      });

      document.dispatchEvent(event);
      skeleton.style.display = 'none';
    } catch (error) {
      console.error('Error to fetch:', error);
    }
  }
}

function showTab(container, tabIndex) {
  const tabContent = container.querySelector(selectors.tabContents);
  const selectedButton = container.querySelectorAll(selectors.tabButtons)[tabIndex];
  removeCurrentClassFromButtons(container);
  tabContent.style.display = 'block';

  if (selectedButton) {
    selectedButton.classList.add('current');

    fetchAndDisplayProducts(container, tabIndex);
  }
}

async function initTabs() {
  const tabContainers = document.querySelectorAll(selectors.tabContainer);
  const tabContainersList = tabContainers && tabContainers.length ? Array.from(tabContainers) : [];

  if (tabContainersList.length) {
    for (let index = 0; index < tabContainersList.length; index++) {
      const tabContainer = tabContainersList[index];
      const buttonsContainer = tabContainer.querySelector('[data-hfilter-collection]');
      const currentCollection = buttonsContainer.getAttribute('data-hfilter-collection');
      const currentFilterKey = buttonsContainer.getAttribute('data-hfilter-param-key');
      const specificFiltersActive = buttonsContainer.getAttribute('data-hfilter-specific-filters');


      if (!specificFiltersActive) {
        const response = await fetch(`https://${window.location.hostname + Shopify.routes.root}/collections/${currentCollection}?view=api-filters`);
        const responseBody = await response.text();
        const responseHtml = new DOMParser().parseFromString(responseBody, 'text/html');
        const filterElement = responseHtml.querySelector('body');
        const filterData = JSON.parse(filterElement.innerText);
        const currentFilterData = filterData.filter((filter) => (filter.param_name === currentFilterKey));

        if (currentFilterData && currentFilterData.length) {
          currentFilterData[0].values.map((value) => {
            const buttonTemplate = tabContainer.querySelector('[' + strings.attrPillFilterTemplate + ']');
            const buttonClone = buttonTemplate.cloneNode(true);
            const searchParam = value.url.split('?')[1].split('&')[0];
            buttonClone.setAttribute(strings.attrSearch, searchParam);
            buttonClone.innerText = value.value;
            buttonClone.removeAttribute(strings.attrPillFilterTemplate);
            buttonsContainer.appendChild(buttonClone);
          });
        }
      }

      const tabButtons = tabContainer.querySelectorAll(selectors.tabButtons);

      tabButtons.forEach((button, i) => {
        button.addEventListener('click', () => showTab(tabContainer, i));
      });

      showTab(tabContainer, 0);
    }
  }
}

initTabs();
